import { createContext, useContext, useState } from "react";

const MultiStepContext = createContext();

const StepProvider = ({ children }) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [features, setFeatures] = useState()
    const [userData, setUserData] = useState([]);
    const [finalData, setFinalData] = useState([]);
    const [featureCount, setFeatureCount] = useState(0);
    const [featureHierarchy, setFeatureHierarchy] = useState([]);

    return (
        <MultiStepContext.Provider
            value={{
                currentStep,
                setCurrentStep,
                userData,
                setUserData,
                finalData,
                setFinalData,
                setFeatures,
                features,
                featureCount,
                setFeatureCount,
                featureHierarchy,
                setFeatureHierarchy,
            }}
        >
            {children}
        </MultiStepContext.Provider>
    )
}

export const useMultiStepProvider = () => useContext(MultiStepContext);
export default StepProvider;